import { NgModule } from "@angular/core";
import { CommonModule } from "common";
import { SharedModule } from "../shared/shared.module";
import { EntityDocumentsListComponent } from "./components/entity-documents-list/entity-documents-list.component";
import { EntityDocumentsRoutingModule } from "./entity-documents-routing.module";
import { RequestStatementDialogModule } from "../document/request-statement-dialog/request-statement-dialog.module";

@NgModule({
  imports: [SharedModule, CommonModule, EntityDocumentsRoutingModule, RequestStatementDialogModule],
  declarations: [EntityDocumentsListComponent],
})
export class EntityDocumentsModule {}
